//generic date range pickers
$(function () {
    var dateRangePickers = $(".daterange-picker");    
    if (dateRangePickers.length) {
        const start = moment().subtract(29, 'days');
        const end = moment();
        dateRangePickers.each((ind, ele) => {
            var dateRangePicker = $(ele);
            var dateRangeStart = dateRangePicker.siblings(".daterange-picker-start");
            var dateRangeEnd = dateRangePicker.siblings(".daterange-picker-end");
            const label = dateRangePicker.attr('placeholder');
            const todayText = dateRangePicker.attr('data-today');
            const tomorrowText = dateRangePicker.attr('data-tomorrow');
            const next7DaysText = dateRangePicker.attr('data-7days');
            const next30DaysText = dateRangePicker.attr('data-30days');
            const customRangeText = dateRangePicker.attr('data-customrange');
            const fromText = dateRangePicker.attr('data-fromtext');
            const toText = dateRangePicker.attr('data-totext');
            const applyText = dateRangePicker.attr('data-applytext');
            const clearText = dateRangePicker.attr('data-canceltext');
            const monthsString = dateRangePicker.attr('data-months');
            const monthsArray = monthsString.split(',');
            const daysString = dateRangePicker.attr('data-days');
            const daysArray = daysString.split(',');

            var rangesObject = {};
            rangesObject[todayText] = [moment(), moment()];
            rangesObject[tomorrowText] = [moment().add(1, 'days'), moment().add(1, 'days')];
            rangesObject[next7DaysText] = [moment(), moment().add(6, 'days')];
            rangesObject[next30DaysText] = [moment(), moment().add(29, 'days')];

            dateRangePicker.daterangepicker({
                startDate: start,
                endDate: end,
                opens: 'left',
                label: label,
                autoUpdateInput: false,
                locale: {
                    format: 'DD/MM/YYYY',
                    customRangeLabel: customRangeText,
                    applyLabel: applyText,
                    cancelLabel: clearText,
                    toLabel: toText,
                    fromText: fromText,
                    monthNames: monthsArray,
                    daysOfWeek: daysArray
                },
                ranges: rangesObject,
            }, function (start, end, label) {
                dateRangeStart.val(start.format('DD/MM/YYYY'));
                dateRangeEnd.val(end.format('DD/MM/YYYY'));
                dateRangeStart.trigger('change');
                dateRangePicker.val(start.format('DD/MM/YYYY') + '-' + end.format('DD/MM/YYYY'));
            });

            dateRangePicker.on('clear.daterangepicker', function (ev, picker) {
                dateRangePicker.val('');
                dateRangeStart.val('');
                dateRangeEnd.val('');
            });
        });
    }
})